// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development';

// Base URLs
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (isDevelopment ? 'http://localhost:3001/api/v1' : 'https://api.streamio.ai/api/v1');

export const WS_BASE_URL = process.env.REACT_APP_WS_URL || 
  (isDevelopment ? 'ws://localhost:3001' : 'wss://api.streamio.ai');

// Subscription configuration
export const subscriptionConfig = {
  urls: {
    production: process.env.REACT_APP_SUBSCRIPTION_URL_PRODUCTION || 'https://www.streamio.ai/pricing',
    development: process.env.REACT_APP_SUBSCRIPTION_URL_DEVELOPMENT || 'http://localhost:3000/pricing',
    staging: process.env.REACT_APP_SUBSCRIPTION_URL_STAGING || 'https://staging.streamio.ai/pricing',
    test: process.env.REACT_APP_SUBSCRIPTION_URL_TEST || 'http://localhost:3000/pricing'
  },
  getSubscriptionUrl: (): string => {
    const env = process.env.NODE_ENV || 'development';
    return subscriptionConfig.urls[env as keyof typeof subscriptionConfig.urls] || subscriptionConfig.urls.development;
  },
  plans: {
    free: 'free',
    premium: 'premium',
    pro: 'pro',
    enterprise: 'enterprise'
  },
  statuses: {
    active: 'active',
    canceled: 'canceled',
    past_due: 'past_due',
    unpaid: 'unpaid',
    unsubscribed: 'unsubscribed'
  }
};

// Export the function for direct import
export const getSubscriptionUrl = (): string => subscriptionConfig.getSubscriptionUrl();

// Specific endpoints
export const ENDPOINTS = {
  AI_CHAT: `${API_BASE_URL}/ai/chat`,
  CONVERSATIONS: `${API_BASE_URL}/conversations`,
  USERS_ME: `${API_BASE_URL}/users/me`,
  USERS_SETTINGS: `${API_BASE_URL}/users/settings`,
  MEDIA_UPLOAD: `${API_BASE_URL}/media/upload`,
  AI_ANALYZE_SCREEN: `${API_BASE_URL}/ai/analyze-screen`,
  HEALTH: `${API_BASE_URL}/health`,
} as const;

// Helper function for dynamic endpoints (like conversations with ID)
export const getConversationEndpoint = (conversationId: string) => 
  `${API_BASE_URL}/conversations/${conversationId}`;

// WebSocket namespaces
export const WS_NAMESPACES = {
  LIVE_SCREEN: `${WS_BASE_URL}/live-screen`,
  CONVERSATIONS: `${WS_BASE_URL}/conversations`,
} as const;

// Environment info
export const ENVIRONMENT = {
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: !isDevelopment,
  API_BASE: API_BASE_URL,
  WS_BASE: WS_BASE_URL,
} as const;

// Debug logging (only in development)
if (isDevelopment) {
  console.log('🔧 API Configuration:', {
    API_BASE_URL,
    WS_BASE_URL,
    ENDPOINTS,
    WS_NAMESPACES,
    subscriptionUrl: getSubscriptionUrl(),
  });
} 